import React from "react";
import { Zap, Lock, Loader2, PackageOpen } from "lucide-react";
import { SX } from "../studioTokens";
import { fmtNum } from "./billingConst";

/* One-time credit packs. Purchasable only while can_buy_addons is true — the
   backend rejects addon-checkout/ otherwise, so the locked variant explains
   why rather than showing a button that 402s. */
const CreditAddOns = ({ addons, locked, busy, onBuy }) => {
  // The current staging catalog ships no `addons` key at all — say so rather
  // than rendering an empty grid that reads as a broken section.
  if (!addons.length) {
    return (
      <div className={`${SX.card} py-9 px-6 text-center`}>
        <PackageOpen size={20} className="text-[#8A8A90] mx-auto mb-2.5" />
        <div className="text-[13px] text-[#52525B] max-w-[440px] mx-auto leading-[1.5]">
          The backend isn't offering any credit packs right now. They'll appear here automatically once the catalog
          includes them.
        </div>
      </div>
    );
  }

  if (locked) {
    return (
      <div className={`${SX.card} py-9 px-6 text-center`}>
        <Lock size={20} className="text-[#8A8A90] mx-auto mb-2.5" />
        <div className="text-[13px] text-[#52525B] max-w-[420px] mx-auto leading-[1.5]">
          Add-on packs top up an active paid plan. Subscribe to a plan first and they'll unlock here.
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {addons.map((pack) => {
        const pending = busy === `addon:${pack.key}`;
        return (
          <div key={pack.key} className={`${SX.card} p-5 flex items-center gap-4`}>
            <div className="w-11 h-11 rounded-[12px] bg-[#FBF5FA] text-[#A04A97] flex items-center justify-center flex-shrink-0">
              <Zap size={19} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-[14px] font-semibold text-[#1A1A1A]">{pack.name}</div>
              <div className="text-[12.5px] text-[#52525B] mt-0.5">
                {fmtNum(pack.credits)} credits
                {pack.credits > 0 && ` · $${((pack.price_usd / pack.credits) * 1000).toFixed(2)} per 1k`}
              </div>
              <div className="text-[11.5px] text-[#8A8A90] mt-1">One-time · added to your balance immediately</div>
            </div>
            <div className="text-right flex-shrink-0">
              <div className="text-[20px] font-semibold text-[#1A1A1A] mb-2">${fmtNum(pack.price_usd)}</div>
              <button
                className={`${SX.btn} ${SX.btnSm} ${SX.btnSoft}`}
                disabled={!!busy}
                onClick={() => onBuy(pack)}
              >
                {pending && <Loader2 size={12} className="animate-spin" />} Buy
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CreditAddOns;
